import { useEffect, useState } from "react";

const Stepper = () => {
  const [deviceWidth, setDeviceWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", renderRespectiveSvg);
    return () => window.removeEventListener("resize", renderRespectiveSvg);
  }, []);

  const renderRespectiveSvg = () => {
    setDeviceWidth(window.innerWidth);
  };

  return (
    <div className="flex justify-center items-center gap-5 xs:my-3 lg:my-6">
      <div id="select-your-prizes" className="flex gap-2 font-jost items-center">
        <div className="font-jost relative lg:border-2 xs:border-[1.2px] border-[#E0E0E0] flex rounded-full justify-center items-center text-[#000] xs:text-[9px] lg:text-[12px] font-medium leading-[12px] lg:w-[40px] lg:h-[40px] xs:w-[24px] xs:h-[24px]">
          1/3
          {deviceWidth >= 1024 ? (
            <svg
              className="absolute -top-[2px] -right-[2px]"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="30"
              viewBox="0 0 20 30"
              fill="none">
              <path
                d="M0 1C0 0.447715 0.448009 -0.0026085 0.999603 0.0249921C4.12775 0.181518 7.18048 1.07095 9.90917 2.62737C12.9279 4.3492 15.4458 6.8279 17.2148 9.81917C18.9839 12.8104 19.9429 16.2111 19.9975 19.6859C20.0469 22.8268 19.3556 25.9304 17.9858 28.7471C17.7443 29.2437 17.1338 29.4194 16.6498 29.1533C16.1659 28.8873 15.9919 28.2803 16.2307 27.7823C17.4347 25.2713 18.0417 22.5107 17.9978 19.7173C17.9487 16.5899 17.0855 13.5294 15.4934 10.8373C13.9012 8.14511 11.6351 5.91428 8.91825 4.36463C6.49148 2.98042 3.77994 2.18239 0.999525 2.02777C0.448093 1.9971 0 1.55228 0 1Z"
                fill="#FF8200"
              />
            </svg>
          ) : (
            <svg
              className="absolute -top-[1px] -right-[1px]"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="18"
              viewBox="0 0 12 18"
              fill="none">
              <path
                d="M0 0.6C0 0.268629 0.268806 -0.0015651 0.599763 0.0149953C2.47665 0.108911 4.30829 0.642569 5.9455 1.57642C7.75672 2.60952 9.26748 4.09674 10.3289 5.8915C11.3903 7.68627 11.9658 9.72663 11.9985 11.8115C12.0281 13.6961 11.6134 15.5583 10.7915 17.2482C10.6466 17.5462 10.2803 17.6516 9.9899 17.492C9.69951 17.3324 9.59516 16.9682 9.73843 16.6694C10.4608 15.1628 10.825 13.5064 10.7987 11.8304C10.7692 9.95397 10.2513 8.11764 9.29601 6.50235C8.34073 4.88706 6.98105 3.54857 5.35095 2.61878C3.89489 1.78826 2.26796 1.30943 0.599716 1.21666C0.268857 1.19826 0 0.931371 0 0.6Z"
                fill="#FF8200"
              />
            </svg>
          )}
        </div>
        <div className="flex flex-col lg:gap-1">
          <span className="text-[#28282B] xs:text-[11px] lg:text-[16px] font-bold">Select Your Prizes</span>
          <span className="text-[#696971] xs:text-[9px] lg:text-[14px] leading-[12px]">
            <span className="font-bold">Next: </span>
            <span className="font-medium">Play the game</span>
          </span>
        </div>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M1 6H11H1Z" fill="white" />
        <path d="M6.71429 10.5L11 6L6.71429 10.5Z" fill="white" />
        <path d="M6.71429 1.5L11 6L6.71429 1.5Z" fill="white" />
        <path
          d="M1 6H11M11 6L6.71429 10.5M11 6L6.71429 1.5"
          stroke="#BCBCC0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div id="win-your-dream-car" className="flex gap-2 font-jost items-center">
        <img src="/assets/images/win-your-dream-car.png" alt="Win Your Dream Car" />
        <div className="flex flex-col lg:gap-1">
          <span className="text-[#28282B] xs:text-[11px] lg:text-[16px] font-bold">Win your dream car</span>
          <span className="text-[#696971] xs:text-[9px] lg:text-[14px] font-medium leading-[12px]">
            <span className="font-bold">You can be the next winner</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Stepper;
